<template>
    <v-app>
        <div v-if="!status.isLoadingJourney && status.loadJourneySuccessful">
            <group-card title="Journey Editor" icon="newspaper">
                <template slot="actions">
                    <md-button class="md-primary" @click="goBack">
                        Back
                        <md-tooltip md-direction="top"
                            >Go Back to journey list</md-tooltip
                        >
                    </md-button>
                    <md-button class="md-primary" @click="saveJourney">
                        {{ saveWord }}
                        <md-tooltip md-direction="top">Save Journey</md-tooltip>
                    </md-button>
                </template>
                <v-container fluid>
                    <v-row class="stacked-layout">
                        <v-col>
                            <v-tabs v-model="activeTab" style="width: 100%">
                                <v-tab>Details</v-tab>
                                <v-tab>Typography</v-tab>
                                <v-tab>Colors</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="activeTab" class="grow">
                                <v-tab-item>
                                    <div>
                                        <h3>Details</h3>
                                        <v-row>
                                            <v-col cols="4">
                                                <v-text-field
                                                    label="Title"
                                                    v-model="
                                                        currentJourney.metadata
                                                            .title
                                                    "
                                                    :rules="[rules.required]"
                                                    dense
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <v-text-field
                                                    label="Name"
                                                    v-model="
                                                        currentJourney.name
                                                    "
                                                    :rules="[rules.required]"
                                                    dense
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <v-text-field
                                                    label="Key"
                                                    v-model="currentJourney.key"
                                                    :rules="[rules.required]"
                                                    dense
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="6">
                                                <v-text-field
                                                    label="Description"
                                                    v-model="
                                                        currentJourney.description
                                                    "
                                                    :rules="[rules.required]"
                                                    dense
                                                />
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    label="Logo"
                                                    v-model="
                                                        currentJourney.metadata
                                                            .logo
                                                    "
                                                    :rules="[rules.required]"
                                                    dense
                                                />
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-tab-item>

                                <v-tab-item>
                                    <v-row>
                                        <v-col cols="6">
                                            <div>
                                                <h3>Typography - Content</h3>
                                                <v-select
                                                    label="Font family"
                                                    v-model="fontFamily"
                                                    :items="fontFamilyItems"
                                                    multiple
                                                    dense
                                                />
                                                <v-row>
                                                    <v-col cols="4">
                                                        <v-text-field
                                                            label="Font size"
                                                            v-model="
                                                                fontSizeWithoutUnit
                                                            "
                                                            type="number"
                                                            dense
                                                        >
                                                            <template
                                                                slot="append-outer"
                                                            >
                                                                <div
                                                                    class="text-h6"
                                                                    v-text="
                                                                        'px'
                                                                    "
                                                                ></div>
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <v-text-field
                                                            label="Font weight"
                                                            v-model="
                                                                currentJourney
                                                                    .metadata
                                                                    .typography
                                                                    .font.weight
                                                            "
                                                            type="number"
                                                            dense
                                                        />
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <color-swatch
                                                            :color-name="'Font Color'"
                                                            :color="
                                                                currentJourney
                                                                    .metadata
                                                                    .typography
                                                                    .font.color
                                                            "
                                                            :show.sync="
                                                                showFontColorPicker
                                                            "
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="6">
                                            <div>
                                                <h3>Typography - Title</h3>
                                                <v-select
                                                    label="Font family"
                                                    v-model="fontFamilyTitle"
                                                    :items="fontFamilyItems"
                                                    multiple
                                                    dense
                                                />
                                                <v-row>
                                                    <v-col cols="4">
                                                        <v-text-field
                                                            label="Font size"
                                                            v-model="
                                                                fontSizeTitleWithoutUnit
                                                            "
                                                            type="number"
                                                            dense
                                                        >
                                                            <template
                                                                slot="append-outer"
                                                            >
                                                                <div
                                                                    class="text-h6"
                                                                    v-text="
                                                                        'px'
                                                                    "
                                                                ></div>
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <v-text-field
                                                            label="Font weight"
                                                            v-model="
                                                                currentJourney
                                                                    .metadata
                                                                    .typography
                                                                    .font.weight
                                                            "
                                                            type="number"
                                                            dense
                                                        />
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <color-swatch
                                                            :color-name="'Font Title Color'"
                                                            :color="
                                                                currentJourney
                                                                    .metadata
                                                                    .typography
                                                                    .font.title
                                                                    .color
                                                            "
                                                            :show.sync="
                                                                showFontTitleColorPicker
                                                            "
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>

                                <v-tab-item>
                                    <v-row>
                                        <v-col cols="6">
                                            <div>
                                                <h3>Colors</h3>
                                                <v-row>
                                                    <v-col cols="6">
                                                        <color-swatch
                                                            :color-name="'Primary'"
                                                            :color="
                                                                currentJourney
                                                                    .metadata
                                                                    .color
                                                                    .primary
                                                            "
                                                            :show.sync="
                                                                showPrimaryColorPicker
                                                            "
                                                        />
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <color-swatch
                                                            :color-name="'Secondary'"
                                                            :color="
                                                                currentJourney
                                                                    .metadata
                                                                    .color
                                                                    .secondary
                                                            "
                                                            :show.sync="
                                                                showSecondaryColorPicker
                                                            "
                                                        />
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="6">
                                                        <color-swatch
                                                            :color-name="'Background Primary'"
                                                            :color="
                                                                currentJourney
                                                                    .metadata
                                                                    .color
                                                                    .background
                                                                    .primary
                                                            "
                                                            :show.sync="
                                                                showBackgroundPrimaryColorPicker
                                                            "
                                                        />
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <color-swatch
                                                            :color-name="'Background Secondary'"
                                                            :color="
                                                                currentJourney
                                                                    .metadata
                                                                    .color
                                                                    .background
                                                                    .secondary
                                                            "
                                                            :show.sync="
                                                                showBackgroundSecondaryColorPicker
                                                            "
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container fluid>
                    <v-row class="stacked-layout">
                        <v-col>
                            <v-tabs v-model="activeEditorTab" fluid>
                                <v-tab>Edit Flow</v-tab>
                                <v-tab>Preview Layout</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="activeEditorTab">
                                <!-- Tab 1: Flow Management -->
                                <v-tab-item>
                                    <v-row>
                                        <v-col cols="12">
                                            <h3>Journey Steps</h3>
                                            <FlowManagement />
                                        </v-col>
                                    </v-row>
                                </v-tab-item>

                                <!-- Tab 2: Journey Preview -->
                                <v-tab-item>
                                    <v-row>
                                        <v-col cols="12">
                                            <h3>Preview Layout</h3>
                                            <!-- {{ brandingData }} -->
                                            <!-- <v-btn color="primary" @click="togglePreview">Toggle Preview</v-btn> -->
                                            <JourneyPreview
                                                showPreview="true"
                                                :branding="brandingData"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>
                    </v-row>
                </v-container>
            </group-card>

            <!-- Color picker dialogs -->

            <color-picker
                v-model="currentJourney.metadata.typography.font.color"
                :title="'Font Color'"
                :show.sync="showFontColorPicker"
            />
            <color-picker
                v-model="currentJourney.metadata.typography.font.title.color"
                :title="'Font Title Color'"
                :show.sync="showFontTitleColorPicker"
            />

            <color-picker
                v-model="currentJourney.metadata.color.primary"
                :title="'Primary Color'"
                :show.sync="showPrimaryColorPicker"
            />

            <color-picker
                v-model="currentJourney.metadata.color.background.primary"
                :title="'Background Primary Color'"
                :show.sync="showBackgroundPrimaryColorPicker"
            />

            <color-picker
                v-model="currentJourney.metadata.color.secondary"
                :title="'Secondary Color'"
                :show.sync="showSecondaryColorPicker"
            />

            <color-picker
                v-model="currentJourney.metadata.color.background.secondary"
                :title="'Background Secondary Color'"
                :show.sync="showBackgroundSecondaryColorPicker"
            />
        </div>
        <div v-else-if="status.isLoadingJourney">
            <md-empty-state
                md-icon="hourglass_empty"
                md-label="Loading"
                md-description="Please wait whilst the journey is loading"
            />
        </div>
        <div v-else>
            <md-empty-state
                md-icon="close"
                md-label="No Journey selected"
                md-description="Go to the journey list and select a journey."
            />
        </div>
    </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import { GroupCard } from "@/components";
import {
    ColorPicker,
    ColorSwatch,
    FlowManagement,
    JourneyPreview,
} from "@/components/Journal";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import AlertDialog from "@/components/Dialogs/AlertDialog";

export default {
    components: {
        ColorPicker,
        ColorSwatch,
        FlowManagement,
        WaitingDialog,
        ConfirmDialog,
        AlertDialog,
        GroupCard,
        JourneyPreview,
    },
    data() {
        return {
            status: {
                isLoadingJourney: true,
                loadJourneySuccessful: false,
            },
            rules: {
                required: (val) =>
                    (val || "").length > 0 || "This field is required.",
            },
            dialog: {
                title: null,
                message: null,
            },
            fontFamilyItems: [
                "Quicksand",
                "sans-serif",
                "Open Sans",
                "Arial",
                "Helvetica",
                "Times New Roman",
                "Courier New",
                "Verdana",
                "Georgia",
                "Palatino",
                "Garamond",
                "Bookman",
                "Trebuchet MS",
            ],
            showPrimaryColorPicker: false,
            showBackgroundPrimaryColorPicker: false,
            showSecondaryColorPicker: false,
            showBackgroundSecondaryColorPicker: false,
            showFontColorPicker: false,
            showFontTitleColorPicker: false,
            activeTab: 0,
            activeEditorTab: 0,
            showPreview: false,
            brandingData: {
                sidebarColor: "#EAFBF1",
                textColor: "#333",
                fontFamily: "Arial",
                logo: "https://via.placeholder.com/150",
                urlKey: "apply",
            },
        };
    },
    computed: {
        ...mapGetters("journey", ["currentJourney", "journeySteps"]),
        fontFamily: {
            get: function () {
                if (this.currentJourney.metadata.typography.font.family) {
                    let fonts =
                        this.currentJourney.metadata.typography.font.family.split(
                            ",",
                        );
                    return fonts.map((font) => font.trim());
                }
                return [];
            },
            set: function (newVal) {
                this.currentJourney.metadata.typography.font.family =
                    newVal.join(",");
            },
        },
        fontSizeWithoutUnit: {
            get: function () {
                return this.currentJourney.metadata.typography.font.size.replace(
                    /px$/i,
                    "",
                );
            },
            set: function (newVal) {
                this.currentJourney.metadata.typography.font.size = `${newVal}px`;
            },
        },
        fontFamilyTitle: {
            get: function () {
                if (this.currentJourney.metadata.typography.font.title.family) {
                    let fonts =
                        this.currentJourney.metadata.typography.font.title.family.split(
                            ",",
                        );
                    return fonts.map((font) => font.trim());
                }
                return [];
            },
            set: function (newVal) {
                this.currentJourney.metadata.typography.font.title.family =
                    newVal.join(",");
            },
        },
        fontSizeTitleWithoutUnit: {
            get: function () {
                return this.currentJourney.metadata.typography.font.title.size.replace(
                    /px$/i,
                    "",
                );
            },
            set: function (newVal) {
                this.currentJourney.metadata.typography.font.title.size = `${newVal}px`;
            },
        },
        saveWord() {
            return this.$route.params.journey_id === "new" ? "create" : "save";
        },
    },
    methods: {
        async getJourney() {
            const journeyId = this.$route.params.journey_id;
            this.$modal.show(WaitingDialog, {
                title: "Fetching...",
                message: "Please wait whilst we are loading the journey.",
            });
            try {
                const result = await this.$store.dispatch(
                    "journey/fetchJourney",
                    journeyId,
                );
                this.status.loadJourneySuccessful = result;
            } catch (error) {
                console.error("Failed to fetch journey");
            } finally {
                this.status.isLoadingJourney = false;
                this.$modal.submit();
            }
        },
        async saveJourney() {
            this.$modal.show(WaitingDialog, {
                title: "Saving...",
                message: "Please wait whilst we are saving the journey.",
            });
            try {
                const result = await this.$store.dispatch(
                    "journey/saveJourney",
                    this.currentJourney,
                );
                // save journey step when it is not new application
                const stepResult = await this.$store.dispatch(
                    "journey/saveJourneySteps",
                );
                this.dialog.title = "Journey Saved Successfully";
                this.dialog.message =
                    "Your journey has been saved successfully!";
                const journeyId = this.$route.params.journey_id;
                if (journeyId === "new") {
                    // redirect it
                    this.$router.push(
                        `/administration/journey/${this.currentJourney.id}/edit`,
                    );
                }
            } catch (error) {
                this.dialog.title = "Failed to save the Journey";
                if (typeof error === "string") {
                    this.dialog.message = error;
                } else if (typeof error === "object") {
                    this.dialog.message = Object.entries(error)
                        .map((item) => `${item[0]} - ${item[1].join(", ")}`)
                        .join("\n");
                }
            } finally {
                this.$modal.submit();
                this.$modal.show(AlertDialog, {
                    ...this.dialog,
                });
            }
        },

        togglePreview() {
            this.showPreview = !this.showPreview;
        },
        async goBack() {
            const result = await this.$modal.show(ConfirmDialog, {
                title: "Leaving",
                message:
                    "Do you wish to leave? All unsaved changes will be lost.",
                confirmText: "Confirm Leave",
                cancelText: "Keep Editing",
                cancelButtonColor: "md-danger",
            });
            if (result) {
                this.$router.push("/administration/journeys");
            }
        },
        updateBrandingData(journey) {
            this.brandingData = {
                sidebarColor:
                    journey?.metadata?.color?.background?.secondary ||
                    "#EAFBF1",
                textColor: journey?.metadata?.typography?.font?.color || "#333",
                fontFamily:
                    journey?.metadata?.typography?.font?.family || "Arial",
                logo:
                    journey?.metadata?.logo ||
                    "https://via.placeholder.com/150",
                urlKey: journey?.key || "", // Now correctly coming from `currentJourney.key`
                primaryColor: journey?.metadata?.color?.primary || "",
                secondaryColor: journey?.metadata?.color?.secondary || "",
                name: journey?.name || "Company",
            };
        },
    },
    watch: {
        // Watch changes in the entire `currentJourney` object
        currentJourney: {
            deep: true, // Detects nested changes
            handler(newJourney) {
                this.updateBrandingData(newJourney);
            },
        },
    },
    async mounted() {
        await this.$store.dispatch("journey/fetchSteps");
        await this.getJourney();
    },
};
</script>
<style scoped>
.stacked-layout {
    flex-direction: column !important;
}
.v-tabs,
.v-tabs-items {
    width: 100% !important;
    flex: none !important; /* Prevents flex growth/shrinking */
}
</style>
